import {
  callIfFn,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import $ from "jquery";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {
  addMeasurementAjax,
  redrawMeasurements,
  removeMeasurementAjax
} from "src/components/Planner/planner/measurement";

export class MeasurementAction extends PlannerAction {
  /**
   *
   * @param {MeasurementConnection} measurement
   */
  constructor(measurement) {
    super();
    this.measurement = measurement;
  }
  deviceIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, [this.measurement]);
  }
  serialIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, [this.measurement]);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, [this.measurement]);
  }
  wallIdChanged(from,to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, [this.measurement]);
  }
  measurementIdChanged(from, to) {
    if (this.equalAsString(this.measurement.id, from)) {
      this.measurement.id = to;
    }
  }
}
/* MEASUREMENT START */
export class CreateMeasurementAction extends MeasurementAction {
  /**
   *
   * @param {MeasurementConnection} measurement
   */
  constructor(measurement) {
    super(measurement);
    this.actionName = ts("p_do_action_meas_new", "Creating measurement");
  }
  execute(callback) {
    this.measurement.sentToServerPromise = $.Deferred();
    this.measurement.justAdded = true;
    this.measurement.justDeleted = false;
    PlannerGlobals.measurements.push(this.measurement);
    let oriId = this.measurement.id;
    addMeasurementAjax(this.measurement, function (meas) {
      PlannerGlobals.plannerHistoryManager.measurementIdChanged(oriId, meas.id);
      callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var thisVar = this;
    var id = this.measurement.id;
    this.measurement.justDeleted = true;
    this.measurement.justAdded = false;
    redrawMeasurements();
    removeMeasurementAjax(id, function () {
      PlannerGlobals.measurements = PlannerGlobals.measurements.filter(function (meas) {
        return meas.id != id;
      });
      redrawMeasurements();
      callIfFn(callback, true);
    }, function () {
      thisVar.measurement.justDeleted = false;
      redrawMeasurements();
      callIfFn(callback, false);
    });
  }
}
export class DeleteMeasurementAction extends MeasurementAction {
  /**
   *
   * @param {MeasurementConnection} measurement
   */
  constructor(measurement) {
    super();
    this.measurement = measurement;
    this.actionName = ts("p_do_action_meas_del", "Deleting measurement");
  }
  execute(callback) {
    var thisVar = this;
    var id = this.measurement.id;
    this.measurement.justDeleted = true;
    this.measurement.justAdded = false;
    redrawMeasurements();
    removeMeasurementAjax(id, function () {
      PlannerGlobals.measurements = PlannerGlobals.measurements.filter(function (meas) {
        return meas.id != id;
      });
      redrawMeasurements();
      if (typeof callback === "function") {
        callback(true);
      }
    }, function () {
      thisVar.measurement.justDeleted = false;
      redrawMeasurements();
      if (typeof callback === "function") {
        callback(false);
      }
    });
  }
  undo(callback) {
    this.measurement.sentToServerPromise = $.Deferred();
    this.measurement.justAdded = true;
    this.measurement.justDeleted = false;
    PlannerGlobals.measurements.push(this.measurement);
    let oriId = this.measurement.id;
    addMeasurementAjax(this.measurement, function (meas) {
      PlannerGlobals.plannerHistoryManager.measurementIdChanged(oriId, meas.id);
      callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
}
/* MEASUREMENT END */
